/** Tài nguyên + CSS dùng chung cho theme "Hái Cà Rốt" (bộ ảnh nông trại). */
export const ASSET = "/games/hai-ca-rot";

/** Khung ảnh đáp án A–D. */
export const CARROT_ANSWERS = [
  { key: "A", img: `${ASSET}/question/dap_an_A.png` },
  { key: "B", img: `${ASSET}/question/dap_an_B.png` },
  { key: "C", img: `${ASSET}/question/dap_an_C.png` },
  { key: "D", img: `${ASSET}/question/dap_an_D.png` },
];

/**
 * CSS theo container-query (cqw/cqh) để chữ & nút co giãn theo KHUNG GAME (không
 * theo viewport) — chạy đẹp cả khi nhúng nhỏ (chơi thử / phụ huynh) lẫn toàn màn hình.
 */
export const CRT_CSS = `
.crt-frame{ container-type:size; font-family:var(--font-sans,"Be Vietnam Pro",system-ui,sans-serif); }
.crt-frame img,.crt-frame button{ -webkit-user-drag:none; user-select:none; }

.crt-ctrl{ width:5cqw; height:5cqw; min-width:26px; min-height:26px; display:grid; place-items:center;
  padding:1.1cqw; border-radius:999px; color:#fff; background:#e0741ee6; box-shadow:0 .3cqw .6cqw #6b3b0a66; cursor:pointer; border:0; }
.crt-ctrl:hover{ background:#f2861f; transform:scale(1.06); }

.crt-btn{ position:absolute; border:0; padding:0; background:transparent; cursor:pointer;
  transition:transform .18s cubic-bezier(.2,.9,.25,1.2),filter .18s ease; }
.crt-btn>img{ display:block; width:100%; height:100%; object-fit:contain; pointer-events:none; }
.crt-btn:hover:not(:disabled),.crt-btn:focus-visible:not(:disabled){ transform:scale(1.055); filter:brightness(1.08) drop-shadow(0 .45cqw .35cqw #573b1738); }
.crt-btn:active:not(:disabled){ transform:scale(.97); }
.crt-btn:disabled{ cursor:not-allowed; opacity:.5; filter:grayscale(.25); }
/* Biến thể căn giữa ngang: giữ translateX(-50%) khi hover/active. */
.crt-btn-cx{ transform:translateX(-50%); }
.crt-btn-cx:hover:not(:disabled),.crt-btn-cx:focus-visible:not(:disabled){ transform:translateX(-50%) scale(1.055); filter:brightness(1.08) drop-shadow(0 .45cqw .35cqw #573b1738); }
.crt-btn-cx:active:not(:disabled){ transform:translateX(-50%) scale(.97); }

.crt-carrot{ border:0; padding:0; background:transparent; display:flex; align-items:flex-end; justify-content:center;
  cursor:pointer; transition:transform .2s ease,filter .2s ease,opacity .3s ease; transform-origin:50% 88%; }
.crt-carrot>img{ width:auto; height:auto; max-width:80%; max-height:84%; object-fit:contain; pointer-events:none; filter:drop-shadow(0 .4cqw .3cqw #53331138); }
.crt-carrot:hover:not(:disabled),.crt-carrot:focus-visible:not(:disabled){ transform:translateY(-3%) scale(1.08); filter:brightness(1.08); z-index:5; }
.crt-carrot-wrong{ cursor:default; }
.crt-carrot-done{ opacity:0; pointer-events:none; transform:translateY(10%) scale(.5); }

.crt-answer{ position:relative; border:0; padding:0; background:transparent; display:grid; place-items:center;
  cursor:pointer; transition:transform .18s ease,filter .18s ease; }
.crt-answer>img{ position:absolute; inset:0; width:100%; height:100%; object-fit:fill; pointer-events:none; }
.crt-answer:hover:not(:disabled){ transform:scale(1.04); filter:brightness(1.06) drop-shadow(0 .4cqw .35cqw #5935123b); }
.crt-answer-selected{ filter:drop-shadow(0 0 .8cqw #fff) drop-shadow(0 0 1.1cqw #ffe65c); transform:scale(1.03); }
.crt-answer-correct{ filter:brightness(1.08) drop-shadow(0 0 1cqw #7be06a); }
.crt-answer-wrong{ filter:drop-shadow(0 0 1cqw #ff6a6a); animation:crtShake .35s; }

.crt-qtext{ color:#64300c; font-weight:800; line-height:1.16; }
.crt-atext{ color:#60300f; font-weight:800; line-height:1.12; }

.crt-rabbit-float{ animation:crtFloat 3.8s ease-in-out infinite; transform-origin:50% 100%; }
.crt-rabbit-happy{ animation:crtHappy 1.6s ease-in-out infinite; transform-origin:50% 100%; }
.crt-screen{ animation:crtScreenIn .28s ease both; }
.crt-scorepop{ animation:crtScorePop .6s cubic-bezier(.18,.95,.2,1.25) both; }
.crt-panel-in{ animation:crtPanelIn .5s cubic-bezier(.2,.9,.25,1.25) both; }

@keyframes crtScreenIn{ from{opacity:0;transform:scale(1.01)} to{opacity:1;transform:scale(1)} }
@keyframes crtPanelIn{ from{opacity:0;transform:scale(.84)} to{opacity:1;transform:scale(1)} }
@keyframes crtFloat{ 0%,100%{transform:translateY(0) rotate(-1deg)} 50%{transform:translateY(-1.4%) rotate(1deg)} }
@keyframes crtHappy{ 0%,100%{transform:translateY(0) rotate(-1deg)} 50%{transform:translateY(-2.4%) rotate(1.5deg)} }
@keyframes crtShake{ 0%,100%{transform:translateX(0)} 25%{transform:translateX(-3%)} 75%{transform:translateX(3%)} }
@keyframes crtScorePop{ 0%{opacity:0;transform:translate(-50%,-50%) scale(.35)} 70%{transform:translate(-50%,-50%) scale(1.12)} 100%{opacity:1;transform:translate(-50%,-50%) scale(1)} }
@media(prefers-reduced-motion:reduce){ .crt-frame *{ animation:none!important; } }
`;
